import dayjs from 'dayjs'
import type { SpendCapPeriod } from '../types'

export const formatDateOfBirth = (
  dateOfBirth: string,
  startFormat: string = 'MM/DD/YYYY',
  endFormat: string = 'YYYY-MM-DD'
) => dayjs(dateOfBirth, startFormat, 'en', true).format(endFormat)

export const formatPhoneNumber = (phone: string) => `+1${phone.replace(/\D/g, '')}`

export const formatUsdAmount = (amount: string) => Number.parseInt(amount.replace(/\D/g, ''), 10)

export const formatDisplayPhoneNumber = (phone: string) => {
  const cleaned = phone?.replace(/\D/g, '')
  const match = cleaned?.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`
  }
  const countryCodeMatch = cleaned?.slice(1, cleaned.length).match(/^(\d{3})(\d{3})(\d{4})$/)
  if (countryCodeMatch) {
    return `(${countryCodeMatch[1]}) ${countryCodeMatch[2]}-${countryCodeMatch[3]}`
  }
  return ''
}

export const formatDisplayUsdAmount = (amount: number | string) => {
  const usdLocale = Intl.NumberFormat('en-US')

  if (Number.isNaN(Number(amount))) {
    return ''
  }

  return `$${usdLocale.format(Number(amount))}`
}

export const formatDisplayPercentage = (num: string | number) =>
  (Number(num) / 100).toLocaleString('en', { style: 'percent' })

// Formats a rewards spend cap for display, e.g. { amount: 5000, period: 'YEARLY' } -> "up to $5,000 per
// year". Uses the full dollar amount and spells the period out as "per year" / "per month".
export const formatSpendCap = ({
  amount,
  period,
}: {
  amount: number
  period: SpendCapPeriod
}): string => {
  const periodLabel = period === 'YEARLY' ? 'per year' : 'per month'
  return `up to ${formatDisplayUsdAmount(amount)} ${periodLabel}`
}

export const moneyFormatter = (value: string): string =>
  value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const convertJsDateToArray = (date: Date) => {
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')
  const year = date.getFullYear()

  return [month, day, year]
}
